import { useEffect, useMemo, useState } from 'react';
import { Search } from 'lucide-react';
import { LoadingState, ErrorState } from '../../components/LoadingState';
import { useGenerateGlossary } from '../../api/queries';
import styles from './GlossaryView.module.css';

type Term = {
  term: string;
  definition: string;
  context?: string;
};

export function GlossaryView() {
  const mut = useGenerateGlossary();
  const [q, setQ] = useState('');

  useEffect(() => {
    if (!mut.data && !mut.isPending && !mut.error) mut.mutate({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const terms: Term[] = useMemo(() => {
    const data = mut.data as any;
    const list: Term[] = data?.content?.glossary?.terms ?? data?.content?.glossary ?? [];
    return [...list].sort((a, b) => a.term.localeCompare(b.term, 'es'));
  }, [mut.data]);

  const filtered = useMemo(() => {
    if (!q.trim()) return terms;
    const needle = q.toLowerCase();
    return terms.filter(
      (t) =>
        t.term.toLowerCase().includes(needle) ||
        t.definition.toLowerCase().includes(needle)
    );
  }, [q, terms]);

  if (mut.isPending) return <LoadingState label="Extrayendo términos clave…" />;
  if (mut.error) return <ErrorState error={mut.error} onRetry={() => mut.mutate({})} />;

  return (
    <div className={styles.view}>
      <div className={styles.searchWrap}>
        <Search size={16} strokeWidth={2.2} className={styles.searchIcon} />
        <input
          className={styles.search}
          placeholder="Buscar término…"
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />
      </div>

      <div className={styles.scroll}>
        {filtered.length === 0 ? (
          <p className={styles.empty}>Sin resultados para "{q}".</p>
        ) : (
          <ul className={styles.list}>
            {filtered.map((t, i) => (
              <li key={i} className={styles.entry}>
                <h4 className={styles.term}>{t.term}</h4>
                <p className={styles.def}>{t.definition}</p>
                {t.context && <p className={styles.ctx}>{t.context}</p>}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
